import useConfigurationStore from "../store/configurationStore.ts";
import "../sass/configurator.sass";
import "../sass/app-collapse.sass";
import {useEffect, useState} from "react";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import _ from "lodash";
import CollapseElement from "./molecules/CollapseElement.tsx";
import Switch from "react-switch";
import {HerbergementChoice} from "./HerbergementChoice.tsx";
import AjaxApi from "../API/ajax.ts";
declare const dataProductId: number;
declare const configTrads: any;
declare const basketLink: any;


const _trad = (key: string) : string =>  configTrads[key] ? configTrads[key] : key;



const Configurator = () => {
    if(!dataProductId) return '';

    const store = useConfigurationStore(state => state);

    const [nbPackOptions, setNbPackOptions] = useState(['1']);
    const [packagesOptions, setPackagesOptions] = useState<{ value: string, label: string }[]>([]);
    const [dateOptions, setDateOptions] = useState<{ value: string, label: string }[]>([]);
    const [transportOptions, setTransportOptions] = useState<{ value: string, label: string }[]>([{ value: "Pas de transport", label: _trad("Pas de transport") }]);
    const [billetOptions, setBilletOptions] = useState<{ value: string, label: string }[]>([]);
    const [packageWithoutHebergement, setPackageWithoutHebergement] = useState(false);
    const [price, setPrice] = useState(0);
    const [loadingPrice, setLoadingPrice] = useState(false);
    const [nbPack, setNbPack] = useState(0);
    const [firstLoad, setFirstLoad] = useState(false);
    const [errors, setErrors] = useState<{type: string,message: string}[][]>([]);
    const [showError, setShowError] = useState(false);
    const [loadingSend, setLoadingSend] = useState(false);
    const [packageSoldOut, setPackageSoldOut] = useState(null);
    const [transportSoldOut, setTransportSoldOut] = useState(null);
    const [packageFirstLoaded, setPackageFirstLoaded] = useState(false);
    const [errorPackage,setErrorPackage] = useState<string | null>(null);

    useEffect(() => {
        setNbPackOptions(_.range(1,Math.max(...store.packageConfig.package.packages.map(p => p.nombre_de_package_maximum))+1).map((i) => i.toString()));
        setPackagesOptions(store.packageConfig.package.packages.map((p) => ({value: p.nom_du_package, label: p.nom_du_package+' ('+p.prix_du_package_par_personne+'€)'})));
        if(store.packageConfig.gestion_des_dates.plusieurs_dates_possibles){
            setDateOptions(store.packageConfig.gestion_des_dates.listes_des_dates.map((d) => ({value: d, label: d})));
        }else{
            store.setChoice("date",store.packageConfig.gestion_des_dates.date_unique);
        }

    }, [store.packageConfig]);

    useEffect(() => {
        if(store.choices.package){
            const packageSelected = store.packageConfig.package.packages.find((p) => p.nom_du_package === store.choices.package);
            if(packageSelected){

                const visiblePackages: string[] = [];
                const newPackagesOptions = store.packageConfig.package.packages
                    .filter((p => p.nombre_de_package_minimum <= (store.choices.nbPack || 1) && p.nombre_de_package_maximum >= (store.choices.nbPack || 1)))
                    .map((p) => {
                        visiblePackages.push(p.nom_du_package);
                        return{
                            value: p.nom_du_package,
                            label: p.nom_du_package + ' (' + p.prix_du_package_par_personne + '€)'
                        }
                    })

                setPackagesOptions(store.packageConfig.package.packages.map((p) =>  {return { value: p.nom_du_package,  label: p.nom_du_package + ' (' + p.prix_du_package_par_personne + '€)' }}));
                setErrorPackage(null)
                if(store.choices.package && !newPackagesOptions.some((p) => p.value === store.choices.package )) {
                    if(packageSelected.nombre_de_package_minimum > (store.choices.nbPack || 1)){
                        setErrorPackage(_trad("Attention, minimum de réservation en ligne : ") + packageSelected.nombre_de_package_minimum + _trad(" personnes"));
                    }else if(packageSelected.nombre_de_package_maximum < (store.choices.nbPack || 1)){
                        setErrorPackage(_trad("Attention, maximum de réservation en ligne : ") + packageSelected.nombre_de_package_maximum + _trad(" personnes"));
                    }

                    toggle("package", true)
                }else{
                    setErrorPackage(null)
                }


                const tab = document.getElementById(packageSelected.id_du_bouton_selecteur_de_package)
                if(tab) tab.click();
                setPackageWithoutHebergement(!packageSelected.package_avec_hebergement);
                if(packageFirstLoaded || !store.choices.itemKey) {
                    store.setChoice("chambres", []);
                    store.setChoice("categorieChambre", null);
                    store.setChoice("moreDays", null);
                    if(!store.packageConfig.package.desactiver_les_billets){
                        const typeBillet = packageSelected.types_de_billet || [];
                        if (typeBillet.length > 0) {
                            store.setChoice("billet", typeBillet[0].intitule_du_type_de_billet);
                        } else {
                            store.setChoice("billet", null);
                        }
                    }
                }
                setPackageFirstLoaded(true);
                if(!store.packageConfig.package.desactiver_les_billets){
                    setBilletOptions((packageSelected.types_de_billet || []).map((billet) => ({value: billet.intitule_du_type_de_billet, label: billet.intitule_du_type_de_billet+' ' + (billet.prix_du_type_de_billet === 0 ? _trad('(Inclus)') : '(+'+billet.prix_du_type_de_billet+'€)')})));
                }

                if(!store.packageConfig.package.mode_hospitalite && packageSelected?.activer_le_module_transport && (packageSelected?.liste_des_villes_de_depart?.length || 0) > 0){

                    const transportOptions = [{ value: "Pas de transport", label: _trad("Pas de transport")}];
                    const isOffered = store.packageConfig.package.packages.find((p) => p.nom_du_package === store.choices.package)?.transport_inclus_dans_le_prix;
                    packageSelected.liste_des_villes_de_depart?.forEach((d) => {
                        transportOptions.push({value: d.ville_de_depart, label: d.ville_de_depart + ' ' + ((isOffered || d.prix_de_la_ville_de_depart === 0)? _trad('(Inclus)') : ' (+'+d.prix_de_la_ville_de_depart+'€)')});
                    })
                    setTransportOptions(transportOptions);
                }

                store.setPackageDetail(packageSelected);

            }
        }


    }, [store.choices.package]);

    useEffect(() => {
        if(store.choices.nbPack) {
            if (nbPack != store.choices.nbPack) {
                const visiblePackages: string[] = [];
                const newPackagesOptions = store.packageConfig.package.packages
                    .filter((p => p.nombre_de_package_minimum <= (store.choices.nbPack || 1) && p.nombre_de_package_maximum >= (store.choices.nbPack || 1)))
                    .map((p) => {
                        visiblePackages.push(p.nom_du_package);
                        return{
                            value: p.nom_du_package,
                            label: p.nom_du_package + ' (' + p.prix_du_package_par_personne + '€)'
                        }
                    })
                setPackagesOptions(store.packageConfig.package.packages.map((p) =>  {return { value: p.nom_du_package,  label: p.nom_du_package + ' (' + p.prix_du_package_par_personne + '€)' }}));
                if(store.choices.package && !newPackagesOptions.some((p) => p.value === store.choices.package )){
                    store.setChoice("chambres", []);
                    store.setChoice("categorieChambre", null);
                    store.setChoice("moreDays", null);
                    store.setChoice("package", null);
                    open("package")
                }else{
                    setErrorPackage(null)
                    if(firstLoad && store.choices.package && store.choices.nbPack
                    && !packageWithoutHebergement && !store.packageConfig.package.mode_hospitalite
                    ){
                        open(hasErrors("PACKAGE") ? "package" : "hebergement")

                    }
                }
                setNbPack(store.choices.nbPack);
            }
        }

        setLoadingPrice(true);

        AjaxApi.askWizardPrice(store.choices, dataProductId).then((res) => {
            if(res.success) {
                setPackageSoldOut(null)
                setTransportSoldOut(null)
                setPrice(res.data.price);
                const errors: {type: string,message: string}[] =  res.data.errors.map((e: string) => {
                    const split: string[] = e.split("|");
                    return {type: split[0], message: split[1]}
                })
                setErrors(_.values(_.groupBy(errors, 'type')));
                if(res.data.stockLeft){
                    setPackageSoldOut(res.data.stockLeft)
                }if(res.data.stockTransportLeft){
                    setTransportSoldOut(res.data.stockTransportLeft)
                }
            }
            setLoadingPrice(false);
        });
        if(!firstLoad){
            setFirstLoad(true);
        }
    }, [store.choices]);




    const [isOpen, setIsOpen] = useState({
        package: true,
        date: false,
        transport: false,
        hebergement: false,
        billet: false,
        options: false,
        assurances: false,
    })
    function toggle(index: string,forceOpen: boolean = false) {
        if(forceOpen) setIsOpen(() => ({ package: false,date: false,transport: false,hebergement: false,billet: false,options: false,assurances: false, [index]: true }))
        else setIsOpen((s: any) => ({ package: false,date: false,transport: false,hebergement: false,billet: false,options: false,assurances: false, [index]: !s[index] }))
    }
    function open(index: string) {
        setIsOpen(() => ({ package: hasErrors("PACKAGE"),date: hasErrors("DATE"),transport: hasErrors("TRANSPORT"),hebergement: hasErrors("HÉBERGEMENT"),billet: false,options: false,assurances: false, [index]: true }))
        const element = document.querySelector(".section-"+index)
        if(element){
            const y = element.getBoundingClientRect().top + window.scrollY;
            window.scroll({
                top: y-100,
                behavior: 'smooth'
            });
        }

    }

    const send = () => {
        setShowError(true);
        if(!loadingSend){
            if(errors.length === 0){
                setLoadingSend(true);
                AjaxApi.addToCart(store.choices, dataProductId).then((res) => {
                    if(res.success) {
                        window.location.href = basketLink;
                    }
                    setLoadingSend(false);
                }).catch((err) => {
                    console.log(err);
                    setLoadingSend(false);
                });
            }
        }


    }

/*    useEffect(() => {
        console.log("errors", errors);
    }, [errors]);*/


    const hasErrors = (type: string) => {
        return !!errors.find(e => e[0].type === type)
    }

    const getTypeErrors = (type: string): {type: string, message: string}[] => {
        return errors.find(e => e[0].type === type) || []
    }

    return (
        <div id="configurator-container">

            {store.choices.itemKey && <p style={{fontSize:"14px"}}><i className="fas fa-info-circle"></i> {store.packageConfig.package.mode_hospitalite ?  _trad("Vous être en cours de modification d'une hospitalité déjà dans le panier.") : _trad("Vous être en cours de modification d'un package déjà dans le panier.")} <a href={window.location.origin + window.location.pathname}>{_trad("Cliquez ici pour créer un nouveau package")}</a></p>}
            <div className="flex-row-between">
                <strong style={{fontSize:"22px"}}>{_trad("Nombre de participant(s)")}</strong>
                <Dropdown options={nbPackOptions} onChange={(e) => store.setChoice("nbPack",parseInt(e.value))} value={store.choices.nbPack?.toString() || '1'} placeholder={_trad("Sélectionnez le nombre de package")} />
            </div>


            {/* MODULE PACKAGE*/}
            <CollapseElement className="section-package" isOpen={isOpen.package || ((showError || !!packageSoldOut) && hasErrors("PACKAGE"))} toggle={() => toggle("package")} title={store.packageConfig.package.mode_hospitalite ? _trad("Hospitalité"):_trad("Package")}>
                <div>
                    <div className="">
                        {/*<div>Quel {store.packageConfig.package.mode_hospitalite ? "hospitalité":"package"} souhaitez-vous choisir&nbsp;?</div>*/}
                        <Dropdown options={packagesOptions} onChange={(e) => {
                            if(!store.choices.package) setShowError(false)
                            store.setChoice("package",e.value)
                        }} value={store.choices.package || ''} placeholder={store.packageConfig.package.mode_hospitalite ? _trad("Sélectionnez une hospitalité") : _trad("Sélectionnez votre package")} />
                    </div>
                    {errorPackage && <div className="error">
                        <h5 style={{'marginTop':'10px'}}>{_trad(errorPackage)}</h5>
                    </div>}
                    {(showError || packageSoldOut) && hasErrors("PACKAGE")  && <div className="error">
                        {getTypeErrors("PACKAGE").map((e) => <h5 style={{'marginTop':'10px'}}>{_trad(e.message)}</h5>)}
                    </div>}

                </div>
            </CollapseElement>

            <div className={(packageSoldOut || errorPackage) ? "soldout": ""}>
                {/* MODULE DATE*/}
                {store.packageConfig.gestion_des_dates.plusieurs_dates_possibles && <CollapseElement className="section-date" isOpen={isOpen.date ||  (showError && hasErrors("DATE"))} toggle={() => toggle("date")} title={_trad("Date")}>
                    {!store.choices.package && <h5>{_trad("Merci de choisir votre package avant de sélectionner les options de date.")}</h5>}
                    {store.choices.package && <>
                        {store.packageConfig.gestion_des_dates.plusieurs_dates_possibles &&
                            <div className="">
                                {/*<div>Quelle date souhaitez-vous choisir&nbsp;?</div>*/}
                                <Dropdown options={dateOptions} onChange={(e) => store.setChoice("date",e.value)} placeholder={_trad("Sélectionnez une date")} />
                                {showError && hasErrors("DATE")  && <div className="error">
                                    {getTypeErrors("DATE").map((e) => <h5 style={{'marginTop':'10px'}}>{_trad(e.message)}</h5>)}
                                </div>}
                            </div>
                        }
                        {!store.packageConfig.gestion_des_dates.plusieurs_dates_possibles && <div>
                            {_trad("La date est unique :")} <strong>{store.packageConfig.gestion_des_dates.date_unique}</strong>
                        </div>}
                    </>}
                </CollapseElement>}
                {/* MODULE TRANSPORT*/}
                {store.packageDetail?.activer_le_module_transport && !store.packageConfig.package.mode_hospitalite &&
                    <CollapseElement className="section-transport" isOpen={isOpen.transport || transportSoldOut || (showError && hasErrors("TRANSPORT"))} toggle={() => toggle("transport")} title={_trad("Transport")}>
                        {!store.choices.package && <h5>{_trad("Merci de choisir votre package avant de sélectionner les options de transport.")}</h5>}
                        {store.choices.package && <>
                            <div className="">
                                {/*<div>Quelle transport souhaitez-vous choisir&nbsp;?</div>*/}
                                <Dropdown options={transportOptions} onChange={(e) => store.setChoice("transport",e.value)} value={transportOptions[0]} placeholder={_trad("Sélectionnez une ville de départ")} />
                            </div>
                            {(transportSoldOut || (showError && hasErrors("TRANSPORT")))  && <div className="error">
                                {getTypeErrors("TRANSPORT").map((e) => <h5 style={{'marginTop':'10px'}}>{_trad(e.message)}</h5>)}
                            </div>}
                        </>}
                    </CollapseElement>
                }
                {/* MODULE HEBERGEMENT*/}
                {!packageWithoutHebergement && !store.packageConfig.package.mode_hospitalite &&
                    <CollapseElement className="section-hebergement" isOpen={isOpen.hebergement ||  (showError && hasErrors("HÉBERGEMENT"))} toggle={() => toggle("hebergement")} title={_trad("Hébergement")}>
                        {!store.choices.package && <h5>{_trad("Merci de choisir votre package avant de sélectionner les options d'hébergement.")}</h5>}
                        {store.choices.package && <>
                            <HerbergementChoice showError={showError} errors={errors}></HerbergementChoice>
                        </>}
                    </CollapseElement>
                }
                {/* MODULE BILLETERIE*/}
                {!store.packageConfig.package.desactiver_les_billets &&
                <CollapseElement className="section-billet" isOpen={isOpen.billet || (showError && hasErrors("BILLETTERIE"))} toggle={() => toggle("billet")} title={_trad("Billetterie")}>
                    {!store.choices.package && <h5>{_trad("Merci de choisir votre package avant de sélectionner les options de billetterie.")}</h5>}
                    {store.choices.package && <>
                        <div className="">
                            {/*<div>Quel Billet souhaitez-vous choisir&nbsp;?</div>*/}
                            <Dropdown options={billetOptions} onChange={(e) => store.setChoice("billet",e.value)} value={billetOptions.find( b => b.value === store.choices.billet)} placeholder={_trad("Sélectionnez votre billet")} />
                            {showError && hasErrors("BILLETTERIE")  && <div className="error">
                                {getTypeErrors("BILLETTERIE").map((e) => <h5 style={{'marginTop':'10px'}}>{_trad(e.message)}</h5>)}
                            </div>}
                        </div>
                    </>}
                </CollapseElement>}
                {/* MODULE ASSURANCES*/}
                {(store.packageConfig.gestion_assurances.activer_assurance_annulation || store.packageConfig.gestion_assurances.activer_assurance_rapatriement) &&
                    <CollapseElement className="section-assurances" isOpen={isOpen.assurances || (showError && hasErrors("ASSURANCE"))} toggle={() => toggle("assurances")} title={_trad("Assurance")}>
                        {!store.choices.package && <h5>{_trad("Merci de choisir votre package avant de sélectionner les options d'assurance.")}</h5>}
                        {store.choices.package && <>
                            {store.packageConfig.gestion_assurances.activer_assurance_annulation && <div style={{marginBottom: '20px'}}>
                                <label className={"flex-row-start"}>
                                    <Switch
                                        onColor={"#030551"}
                                        onChange={(e:any) => store.setChoice("assuranceAnnulation",e)}
                                        checked={store.choices.assuranceAnnulation}
                                        className="react-switch"
                                    />
                                    <div>{_trad("Je souhaite souscrire à l’assurance annulation – pandémie incluse")} ({store.packageConfig.gestion_assurances.prix_en_pourcentage_de_panier_de_l_assurance_annulation}% {_trad("du total de la commande")})</div>

                                </label>
                            </div>}
                            {store.packageConfig.gestion_assurances.activer_assurance_rapatriement && <div style={{marginBottom: '20px'}}>
                                <label className={"flex-row-start"}>
                                    <Switch
                                        onColor={"#030551"}
                                        onChange={(e:any) => store.setChoice("assuranceRapatriement",e)}
                                        checked={store.choices.assuranceRapatriement}
                                        className="react-switch"
                                    />
                                    <div>{_trad("Je souhaite souscrire à l’assurance Assistance, rapatriement, bagage – pandémie incluse")} ({store.packageConfig.gestion_assurances.prix_assurance_rapatriement}€ {_trad("par personne")})</div>

                                </label>
                            </div>}
                            <div>
                                <label className={"flex-row-start"}>
                                    <Switch
                                        onColor={"#030551"}
                                        onChange={(e:any) => store.setChoice("noAssurance",e)}
                                        checked={store.choices.noAssurance}
                                        className="react-switch"
                                    />
                                    <div><strong>{_trad("Sans assurance")}</strong><br />{_trad("Je ne souhaite pas bénéficier d’assurance")}</div>

                                </label>
                            </div>
                            {showError && hasErrors("ASSURANCE")  && <div className="error">
                                {getTypeErrors("ASSURANCE").map((e) => <h5 style={{'marginTop':'10px'}}>{_trad(e.message)}</h5>)}
                            </div>}
                        </>}
                    </CollapseElement>
                }

                <h2 className={"flex-row-between"} style={{marginTop: '30px'}}>
                    <span style={{fontSize: "24px", lineHeight: "24px"}}>{_trad("Montant total")}</span>
                    <div style={{fontSize: "24px"}} className="price">
                        {loadingPrice && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><rect fill="#C5B177" stroke="#C5B177" strokeWidth="8" width="30" height="30" x="25" y="50"><animate attributeName="y" calcMode="spline" dur="2" values="50;120;50;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate></rect><rect fill="#C5B177" stroke="#C5B177" strokeWidth="8" width="30" height="30" x="85" y="50"><animate attributeName="y" calcMode="spline" dur="2" values="50;120;50;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate></rect><rect fill="#C5B177" stroke="#C5B177" strokeWidth="8" width="30" height="30" x="145" y="50"><animate attributeName="y" calcMode="spline" dur="2" values="50;120;50;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate></rect></svg>}
                        {!loadingPrice && <>{price}</>}&nbsp;€</div>
                </h2>

                {showError && errors.length > 0  && <div className="error">
                    {errors.length === 1 && <h5>{_trad("Une erreur a été détectée dans la section")} {_trad(errors[0][0].type).toLowerCase()}</h5>}
                    {errors.length > 1 && <h5>{_trad("Une erreur a été détectée dans les sections")} {errors.map(s => _trad(s[0].type).toLowerCase()).join(', ')}</h5>}
                </div>}


                {!loadingPrice && store.choices.itemKey && <button className="validate" onClick={send}>{loadingSend ? _trad('Modification en cours') : _trad('Valider la modification')}</button>}
                {!loadingPrice && !store.choices.itemKey && <button className="validate" onClick={send}>{loadingSend ? _trad('Ajout en cours') : _trad('Ajouter au panier')}</button>}

            </div>




{/*
            <pre>{JSON.stringify(store.choices, null, 2)}</pre>
            <hr/>
            <pre>{JSON.stringify(store.packageConfig, null, 2)}</pre>*/}
        </div>
    )
}
export default Configurator;
